import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=4e8ca172&scoped=true"
import script from "./MFA.vue?vue&type=script&lang=js"
export * from "./MFA.vue?vue&type=script&lang=js"
import style0 from "./MFA.vue?vue&type=style&index=0&id=4e8ca172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8ca172",
  null
  
)

export default component.exports